/* eslint-disable global-require */
import vSelect from 'vue-select'
import {
  required, email, notPersian, noZeroStater,
} from '@validations'
import VueRecaptcha from 'vue-recaptcha'
import { mapActions } from 'vuex'
import Password from 'vue-password-strength-meter'
import moment from 'moment'
import store from '@/store'
import { alphanumeric } from '@/mixins/alphanumeric'
import AuthApis from '@/services/apis/auth'
import { changeLang } from '@/auth/utils'
import { getCookieByName, convertSecondsToMinutes } from '@/utils'
import FormApis from '@/services/apis/form'

const auth = new AuthApis()
const formData = new FormApis()

export default {
  components: {
    VueRecaptcha,
    vSelect,
    Password,
  },
  mixins: [alphanumeric],
  data() {
    return {
      senderModal: false,
      checked1: false,
      checked2: false,
      registerStep: 1,
      isLegal: false,
      select: null,
      status: '',
      moment,
      convertSecondsToMinutes,
      form: {
        first_name: '',
        last_name: '',
        email: '',
        password: '',
        password_confirmation: '',
        recaptchaToken: '',
        recaptcha: null,
        mobile_country_code: '',
        mobile: '',
        otp: '',
      },
      pre_country_code_lists: [],
      myFilter: (option, label, search) => {
        const temp = search.toLowerCase()
        return option.name.toLowerCase().indexOf(temp) > -1
          || option.precode.toString().toLowerCase().indexOf(temp) > -1
      },
      language: this.$route.params.lang,

      sideImg: require('@/assets/images/pages/register-v2.svg'),
      required,
      email,
      notPersian,
      noZeroStater,
      passwordFieldType: 'password',
      confirmPasswordFieldType: 'password',
      pending: false,
      passwordError: '',
      passwordScore: 0,
    }
  },

  computed: {
    options() {
      return this.$i18n.locales
    },
    mediaType() {
      return (`${process.env[`VUE_APP_LOGIN_MEDIA_TYPE_${this.$i18n.locale.toUpperCase()}`]}`)
    },
    passwordToggleIcon() {
      return this.passwordFieldType === 'password' ? 'EyeOffIcon' : 'EyeIcon'
    },
    confirmPasswordToggleIcon() {
      return this.confirmPasswordFieldType === 'password' ? 'EyeOffIcon' : 'EyeIcon'
    },
    mediaUrl() {
      if (store.state.appConfig.layout.skin === 'dark') {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.sideImg = (`${process.env[`VUE_APP_LOGIN_MEDIA_${this.$i18n.locale.toUpperCase()}`]}`)
        return this.sideImg
      }
      return (`${process.env[`VUE_APP_LOGIN_MEDIA_${this.$i18n.locale.toUpperCase()}`]}`)
    },
    passwordConfirmation() {
      return String(this.form.password) !== String(this.form.password_confirmation)
    },
    sitekey() {
      return process.env.VUE_APP_RECAPTCHA_SITE_KEY
    },
    isOtpEnabled() {
      return process.env.VUE_APP_IS_ENABLED_OTP === 'true'
    },
  },

  beforeCreate() {
    const token = localStorage.getItem('token')
    if (token) {
      this.$router.push({ name: 'dashboard' })
    }
  },
  beforeMount() {
    this.language = this.options.find(item => item.locale === this.$route.params.lang)
    formData.allproperties().then(res => {
      const result = res.data.results

      this.pre_country_code_lists = result.countries.map(item => ({
        // eslint-disable-next-line global-require, import/no-unresolved, import/no-dynamic-require
        precode: item.precode, id: item.id, name: item.name, image: require(`@/assets/images/flags/${item.abbreviation}.png`),
      }))
    })
  },
  methods: {
    ...mapActions(['register']),
    changeLang(val) {
      changeLang(val.locale)
    },
    async submit() {
      const success = await this.$refs.registerForm.validate()

      // TODO : here call a api and send referralLink to server
      // BUG : cookie in first load not updated, i think this is a bug.
      // this.$cookies.get('referral')

      if (success) {
        this.pending = true
        const lang = [{ language: this.language.locale }]
        const data = JSON.parse(JSON.stringify({
          ...this.form,
          mobile_country_code: this.form.mobile_country_code.precode,
          code: this.form.otp,
          legal_status: this.isLegal ? 'legal_entity' : 'individual',
          ...(getCookieByName('refID') && { referral: getCookieByName('refID') }),
          ...(getCookieByName('google_gcl_id') && { google_gcl_id: getCookieByName('google_gcl_id') }),
          ...(localStorage.getItem('utm_source') && { utm_source: localStorage.getItem('utm_source') }),
          ...(localStorage.getItem('utm_campaign') && { utm_campaign: localStorage.getItem('utm_campaign') }),
          ...(localStorage.getItem('utm_medium') && { utm_medium: localStorage.getItem('utm_medium') }),
        }))
        auth.register(Object.assign(lang[0], data)).then(response => {
          if (response.status === 201 || response.status === 200) {
            window.dataLayer.push({
              event: 'sign_up',
            })
            this.$swal({
              title: response.data?.message,
              icon: 'success',
              timer: 4000,
              showConfirmButton: false,
            })
            localStorage.setItem('token', response.data.results.token)
            localStorage.setItem('authenticated', true)
            this.$router.push({ name: 'register-success' })
          }
        })
          .finally(() => {
            this.pending = false
            this.onCaptchaExpired()
          })
      }
    },
    onVerify(response) {
      this.form.recaptcha = response
    },
    async onCaptchaExpired() {
      this.$refs.recaptcha.reset()
      this.form.recaptcha = null
    },

    showScorePassword(score) {
      this.passwordScore = score
    },
    showFeedbackPassword({ warning }) {
      this.passwordError = warning
    },
    setLegal(val) {
      this.registerStep = 2
      this.isLegal = val
    },
    changeStep(val) {
      this.registerStep = val
    },
    async sendOtp() {
      if (!this.form.mobile_country_code || !this.form.mobile) {
        this.$swal({
          title: this.$t('error'),
          text: this.$t('please_enter_mobile_number'),
          icon: 'error',
          timer: 3000,
          showConfirmButton: false,
        })
        return
      }

      try {
        const response = await auth.sendOtp({
          mobile_country_code: this.form.mobile_country_code.precode,
          mobile: this.form.mobile,
        })

        if (response.status === 200) {
          this.$swal({
            title: this.$t('success'),
            text: this.$t('otp_sent_successfully'),
            icon: 'success',
            timer: 3000,
            showConfirmButton: false,
          })
        }
      } catch (error) {
        this.$swal({
          title: this.$t('error'),
          text: error.response.data.message || this.$t('otp_send_failed'),
          icon: 'error',
          timer: 3000,
          showConfirmButton: false,
        })
      }
    },
  },
}
